import { useEffect, useState } from "react";
import { fetchData } from "./Helpers";
import { FilterInput, RowFiltering } from '@refinitiv-ui/efx-grid/extensions';

export default function HighLevel() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData("Filings_Categories").then(res => {
      setData(res.filter(item => item.highLevelId !== "")); // Filter out items without highLevelId
      setLoading(false);
    });
  }, []);

  function transformData(data) {
    data.map(item => {
      item.highLevelId = parseInt(item.highLevelId);
      return item;
    })
    return data;
  }

  useEffect(() => {
    const grid = document.getElementById("grid");
    const filterInputExt = new FilterInput();
    const rowFilteringExt = new RowFiltering();
    const columns = [
      { name: 'High Level Category ID', field: 'highLevelId', width: 2, scalable: true},
      { name: 'High Level Category', field: 'highLevelCategory', width: 8, scalable: true}
    ]

    grid.config = {
      rowHeight: 40,
      headerRowHeight: 60,
      autoHideScrollbar: false,
      columns: columns,
      dataModel: {
        data: transformData(data)
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      },
      rowFiltering: {
        disabledUI: true
      },
      extensions: [
        rowFilteringExt,
        filterInputExt
      ]
    };
  }, [data]);
  
  
  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>High Level Category Mapping</h4>
      <efx-grid id="grid" className="filings-grid"></efx-grid>
    </div>
  );
}